<template>
  <button
    class="focus:outline-none rounded-full inline-flex"
    :class="[isLightMode() ? lightModeClasses : darkModeClasses]"
    :style="`padding: ${padding_top}px ${padding_right}px ${padding_bottom}px ${padding_left}px`"
    @keydown.enter.exact.prevent="click()"
  >
    <span class="material-icons my-auto" :class="`${iconSize} ${iconColor}`">
      {{ icon }}
    </span>
  </button>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue'

import { useConfigStatePresenter } from '@/presentation/composables/config/useConfigStatePresenter'

export default defineComponent({
  props: {
    icon: {
      type: String,
      required: true
    },
    iconSize: {
      type: String,
      default: ''
    },
    iconColor: {
      type: String,
      default: 'text-white'
    },
    padding_top: {
      type: Number,
      default: 1
    },
    padding_bottom: {
      type: Number,
      default: 1
    },
    padding_left: {
      type: Number,
      default: 1
    },
    padding_right: {
      type: Number,
      default: 1
    },
    color_list: {
      type: Array,
      default: () => ['text-white', 'bg-primary-500', 'hover:bg-primary-400', 'active:bg-primary-300']
    },
    dark_color_list: {
      type: Array,
      default: () => ['text-dark-text', 'bg-dark-400', 'hover:bg-dark-200', 'active:bg-dark-100']
    }
  },
  setup(props, ctx) {
    const { isLightMode } = useConfigStatePresenter()

    const lightModeClasses = computed(() => props.color_list)

    const darkModeClasses = computed(() => props.dark_color_list)

    const click = () => {
      ctx.emit('click')
    }

    return { click, isLightMode, lightModeClasses, darkModeClasses }
  }
})
</script>

<style lang="postcss" scoped></style>
